import React from 'react'
import { useHistory } from 'react-router-dom'
import errorPng from '../assets/img/org/error.png'

const PageNotFound = () => {
    const history = useHistory()

    return (
        <div style={styles.wrapper}>
            <img src={errorPng} alt="Page Not Found" style={styles.image} />
            <h1 style={styles.title}>Page Not Found</h1>
            <p style={styles.message}>
                The page you are looking for does not exist or you do not have access to it.
            </p>
            <button style={styles.button} onClick={() => history.push('/dashboard')}>
                Go to Dashboard
            </button>
        </div>
    )
}

const styles = {
    wrapper: {
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontFamily: 'Segoe UI, sans-serif',
    },
    image: {
        maxWidth: '320px',
        width: '60%',
        marginBottom: '16px',
    },
    title: {
        fontSize: '2rem',
        color: '#1C375D',
        margin: '0 0 8px 0',
    },
    message: {
        fontSize: '1rem',
        color: '#5a6c87',
        margin: '0 0 24px 0',
    },
    button: {
        padding: '10px 22px',
        fontSize: '1rem',
        backgroundColor: '#F47E46',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
    },
}

export default PageNotFound
